import { jsonParse } from '../../shared/utils/string.utils';

class SigninController {
  constructor(PageService, StorageService, ProfileApiService, SessionService, $window, $state, $location, $translate) {
    'ngInject';

    this.PageService = PageService;
    this.StorageService = StorageService;
    this.ProfileApiService = ProfileApiService;
    this.SessionService = SessionService;
    this.$window = $window;
    this.$state = $state;
    this.$location = $location;
    this.$translate = $translate;
  }

  $onInit() {
    const locale = this.$location.search().lang;

    if (locale) {
      this.$translate.use(locale);
    }

    this.SessionService.clearSession();
    this.ProfileApiService.profile().then((response) => {
      this.SessionService.processResponse(response);
    });

    parent.postMessage('disconnected', '*');
  }

  isAutoLogin() {
    return this.$location.search().username && this.$location.search().password;
  }
}

export default SigninController;



// WEBPACK FOOTER //
// ./client/app/pages/signin/signin.controller.js